import angular from 'angular';
import copyComponent from './copy.component';

export default angular.module('components.app.product.copy', [])
  .component('productCopy', copyComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/product/copy/copy.module.js